import {Injectable, OnDestroy} from '@angular/core';
import {ProductScope, RoutingService} from '@spartacus/core';
import {CurrentProductService, LaunchDialogService} from '@spartacus/storefront';
import {BehaviorSubject, Observable, Subscription} from 'rxjs';
import {distinctUntilChanged, filter, switchMap, tap} from 'rxjs/operators';

import {AimoProduct, AimoProductLoading} from '../../model/product.model';
import {AimoGTMProductAttributes, GTMEventCode} from '../gtm/aimo-gtm.model';

import {AimoProductService} from './aimo-product.service';

@Injectable({
    providedIn: 'root',
})
export class AimoCurrentProductService extends CurrentProductService implements OnDestroy {
    private product$ = new BehaviorSubject<AimoProductLoading>(undefined);
    subscription: Subscription = new Subscription();

    constructor(
        protected launchDialogService: LaunchDialogService,
        protected lRoutingService: RoutingService,
        protected lProductService: AimoProductService,
    ) {
        super(lRoutingService, lProductService);
        this.subscription.add(
            this.lRoutingService
                .getRouterState()
                .subscribe((state) =>
                    this.setProduct(state.state.params['productCode']),
                ),
        );
    }

    setProduct(productCode: string): void {
        this.product$.next(new AimoProductLoading(false, productCode));
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    getProduct(scopes?: (ProductScope | string)[] | ProductScope | string): Observable<AimoProduct> {
        return this.getProduct2();
    }

    getProduct2(gtmProductAttributes?: AimoGTMProductAttributes): Observable<AimoProduct> {
        return this.product$.pipe(
            filter((wrapper) => wrapper && wrapper.code !== undefined),
            distinctUntilChanged((prev, curr) => prev.code === curr.code),
            switchMap((wrapper: AimoProductLoading) => {
                //    if (!wrapper.loading) {
                wrapper.loading = true;
                return this.lProductService.getAimoProduct(wrapper.code, gtmProductAttributes).pipe(
                    tap(() => (wrapper.loading = false)),
                    tap((product) =>
                        setTimeout(() => {
                            if (gtmProductAttributes) {
                                // make sure that this one is fired last
                                this.lProductService.fireSingleProductGtmEvent(
                                    {...product, gtmProductAttributes},
                                    GTMEventCode.ViewItem,
                                );
                            }
                        }, 200),
                    ),
                );
            }),
        );
    }
}



